import { render, staticRenderFns } from "./trainingQusetionAnswerInfo.vue?vue&type=template&id=2207dcc7"
import script from "./trainingQusetionAnswerInfo.vue?vue&type=script&lang=js"
export * from "./trainingQusetionAnswerInfo.vue?vue&type=script&lang=js"
import style0 from "./trainingQusetionAnswerInfo.vue?vue&type=style&index=0&id=2207dcc7&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports